import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column">
              <h3 className="footer-title">About OYATRI</h3>
              <p className="footer-description">
                We believe that travel is more than just reaching a destination—it is about creating unforgettable experiences. We specialize in designing customized travel packages that suit every type of traveler, 
                from family vacations and romantic getaways to adventure tours and luxury escapes.

              </p>
            </div>

            <div className="footer-column">
              <h3 className="footer-title">Holidays</h3>
            <ul className="footer-links">
                <li><a href="#" onClick={e => e.preventDefault()}>Popular Tours</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>WorldWide Tours</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>India Tours</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>Honneymoon Packages</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>Family Packages</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-title">Booking</h3>
              <ul className="footer-links">
                <li><a href="#" onClick={e => e.preventDefault()}>How to Book</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>Brochure</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>Travel Insurance</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>Visa Services</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>FAQs</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-title">General</h3>
              <ul className="footer-links">
                <li><a href="#" onClick={e => e.preventDefault()}>About Us</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>Contact Us</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>Privacy Policy</a></li>
                <li><a href="#" onClick={e => e.preventDefault()}>Terms & Conditions</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-title">Contact Us</h3>
              <ul className="footer-contact">
                <li><i className="fas fa-phone-alt" style={{ color: 'brown' }}></i> +91 96256 53930</li>
                <li><i className="fas fa-envelope" style={{ color: 'brown' }}></i> oyatriletsgo@gmail.com</li>
                <li><i className="fas fa-map-marker-alt" style={{ color: 'brown' }}></i> Gali Number 25 & Gali Number 23, Chandan Vihar, New Delhi 110084, Delhi, India</li>
              </ul>
              <div className="social-links">
                <a href="https://facebook.com/oyatriLetsgo" className="social-icon" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f" style={{ color: 'cornflowerblue' }}></i>
                </a>
                <a href="https://instagram.com/oyatritravels" className="social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram" style={{ color: 'white' }}></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; 2026 OYATRI. All rights reserved.</p>
            <div className="payment-methods">
              <span>💳 Visa</span>
              <span>💳 Mastercard</span>
              <span>💳 American Express</span>
            </div>
          </div>
        </div>
      </div>

      <div className="financial-protection">
        <div className="container">
          <p className="protection-text">
            🛡️ All package holidays are financially protected
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
